export enum UserRole {
    patient = 'PATIENT',
    organization = 'ORGANIZATION',
    organizationMember = 'ORGANIZATION_MEMBER',
    cooperator = 'COOPERATOR',
    admin = 'ADMIN',
}
